<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_335_2067)">
            <path d="M8.66693 14.6662C11.3703 14.6613 12.7859 14.595 13.6906 13.6903C14.6669 12.714 14.6669 11.1426 14.6669 7.99992C14.6669 4.85722 14.6669 3.28587 13.6906 2.30956C12.7143 1.33325 11.143 1.33325 8.00027 1.33325C4.85757 1.33325 3.28622 1.33325 2.30991 2.30956C1.40522 3.21425 1.33885 4.62987 1.33398 7.33325" stroke="#D1DBF0" stroke-width="1.2" stroke-linecap="round"/>
            <path d="M2 14.0001L7.33333 8.66675M7.33333 8.66675H3.33333M7.33333 8.66675V12.6667" stroke="#D1DBF0" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
            <clipPath id="clip0_335_2067">
                <rect width="16" height="16" rx="5" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>